import { ActionTree } from 'vuex';
import { httpClient } from '@/http-client/contextify-client';
import { RootStateI } from '../state';
import { FeedbackStateI, FeedbackDataI } from './state';

export const actions: ActionTree<FeedbackStateI, RootStateI> = {
  async submitFeedback(_, payload: FeedbackDataI) {
    const apiPayload = {
      session_id: payload.sessionId,
      user_id: payload.userId,
      action: payload.action,
      bot_response: payload.botResponse,
      model: payload.model,
      other_parameters: payload.otherParameters,
    };
    const response = await httpClient.post('/api/feedback', apiPayload);
    return response.data;
  },
};
